(function ($) {
  var arbeitWrapp = $('.form-elternarbeit');
  var mitgliederWrapp = $('.form-mitglieder');
  var countArbeit = 50000;
  var userRole = $('.form-kontakt').find('[name="user_role"]').val();
  var pagedLoadPost = 1;
  var postsWrapp = $('.loadmore-posts');
  var postsQuery = postsWrapp.data('query');
  var isLoadPost = true;
  var $document = $(document);
  $document.ready(function () {
    $document.on('submit', '.js_profile_form', function (e) {
      e.preventDefault();
      sendProfileFormData($(this), $(this).data('type'));
    });
    $document.on('click', '.js-save-arbeit', function (e) {
      e.preventDefault();
      var $form = $(this).parents('form');
      sendProfileFormData($form, $form.data('type'));
    });
    $document.on('change keyup', '.js-ea-search', function (e) {
      getArbeitByFilter($(this), 'filter');
    });
    $document.on('change keyup', '.js-mitglieder-search', function (e) {
      getMitgliederByFilter($(this));
    });
    $document.on('click', '.js-add-arbeit', function (e) {
      e.preventDefault();
      addNewArbeit($(this));
    });
    $document.on('click', '.js-add-mitglieder', function (e) {
      e.preventDefault();
      addNewMitglieder($(this));
    });
    $document.on('click', '.js-edit-arbeit', function (e) {
      e.preventDefault();
      editArbeit($(this));
    });
    $document.on('click', '.js-change-status', function (e) {
      e.preventDefault();
      var status = $(this).parents('form').find('[name="u_status"]').val();
      var statusData = 'aktiv';
      var statusClass = 'button--dark';
      switch (status) {
        case 'aktiv':
          statusData = 'inaktiv';
          statusClass = 'button--dark status--light';
          break;
      }
      $(this).find('span').text(statusData);
      $(this).removeClass('status--light').addClass(statusClass);
      $(this).parents('form').find('[name="u_status"]').val(statusData);
    });
    $document.on('click', '.js-change-ea-status', function (e) {
      e.preventDefault();
      var statusField = $(this).parents('tr').eq(0).find('[name*=ea_status]');
      var editStatusField = $(this).parents('tr').eq(0).find('[name*=edit_status]');
      var status = statusField.val();
      var statusData = 'prüfung';
      var statusClass = 'status--dark';
      switch (status) {
        case 'prüfung':
          statusData = 'akzeptiert';
          statusClass = 'status--light';
          break;
      }
      $(this).find('span').text(statusData);
      $(this).removeClass('status--light').removeClass('status--dark').addClass(statusClass);
      statusField.val(statusData);
      editStatusField.val('edit');
    });
    $document.on('click', '.js-remove-arbeit', function (e) {
      e.preventDefault();
      var message = 'Would you really delete this work?';
      var result = confirm(message);
      if (result) {
        $(this).parents('tr').eq(0).remove();
        updateRowIndex(arbeitWrapp);
        removeProfileData($(this), 'arbeit');
      }
    });
    $document.on('click', '.js-remove-mitglieder', function (e) {
      e.preventDefault();
      var message = 'Would you really delete this user?';
      var result = confirm(message);
      if (result) {
        $(this).parents('tr').eq(0).remove();
        updateRowIndex(mitgliederWrapp);
        removeProfileData($(this), 'mitglieder');
      }
    });
    $document.on('change', '.js-update-chf', function () {
      var rownData = {};
      $(this).parents('tr').eq(0).find('input:not(.custom-select__input), select').each(function () {
        var name = $(this).attr('name');
        rownData[name] = $(this).val();
      });
      getChfArbeit(rownData, $(this).parents('tr').eq(0), 'edit');
    });
    $document.on('click', '.js-user-edit', function () {
      var editUrl = $(this).data('href');
      if (editUrl) {
        window.location.href = editUrl;
      }
    });
    if (typeof arbeitListung != 'undefined') {
      $document.on('change', '.js-ea-set', function () {
        setArbeitListung($(this));
      });
    }

    /*if (window.location.search.indexOf('tab=') > -1 && $('body').hasClass('backend')) { //delete get param - tab ??
        var newLink = window.location.href.replace(window.location.search, '');
        history.pushState(null, null, newLink);
    }*/

    if (postsWrapp.length && typeof postsQuery != 'undefined') {
      $(window).scroll(function () {
        if (postsQuery.max_num_pages > pagedLoadPost) {
          if ($(window).scrollTop() + $(window).height() >= postsWrapp.height() + postsWrapp.offset().top - $('.header').height() && isLoadPost) {
            isLoadPost = false;
            pagedLoadPost++;
            ajaxLoadMorePost();
          }
        }
      });
    }
    if (arbeitWrapp.length) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + $(window).height() >= (arbeitWrapp.height() + arbeitWrapp.offset().top - $('.header').height()) / 2 && isLoadPost) {
          isLoadPost = false;
          pagedLoadPost++;
          getArbeitByFilter(arbeitWrapp.find($('table')), 'load');
        }
      });
    }
  });
  function ajaxLoadMorePost() {
    postsQuery.paged = pagedLoadPost;
    var data = {
      action: 'load_more_posts',
      query: postsQuery
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        if (data.length) {
          appendPosts(data);
        }
        isLoadPost = true;
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }
  function appendPosts(posts) {
    if (posts.length) {
      var postsHtml = posts.map(function (obj, i) {
        return obj.content;
      });
      postsWrapp.append($(postsHtml.join('')));
    }
  }
  function setArbeitListung(el) {
    var $parent = el.parents('tr').eq(0);
    if (!$parent.length) {
      $parent = el.parents('.table-filter').eq(0);
    }
    var $arbeitSelect = $parent.find('.arbeit-select');
    var $arbeitVal = $arbeitSelect.val();
    var $leistungSelect = $parent.find('.leistung-select');
    var $leistungVal = $leistungSelect.val();
    var is_sel = false;
    if (el.hasClass('arbeit-select')) {
      is_sel = false;
      arbeitListung.forEach(function (el, ind) {
        if (el.arbeit == $arbeitVal && el['leistung'].length) {
          is_sel = true;
          $leistungSelect.find('option').not('option[value=""]').attr('disabled', 'disabled');
          el['leistung'].forEach(function (el2, inx) {
            $leistungSelect.find('option[value="' + el2 + '"]').removeAttr('disabled');
          });
        }
      });
      if (!is_sel) {
        $leistungSelect.find('option').removeAttr('disabled');
      }
      if ($leistungSelect.find('option:selected:disabled').length) {
        $leistungSelect.val('').customSelect('reset');
      }
      $leistungSelect.customSelect('reset');
    }
    if (el.hasClass('leistung-select')) {
      is_sel = false;
      $arbeitSelect.find('option').not('option[value=""]').attr('disabled', 'disabled');
      arbeitListung.forEach(function (el, ind) {
        if (el['leistung'].length) {
          el['leistung'].forEach(function (el2, inx) {
            if (el2 == $leistungVal) {
              is_sel = true;
              $arbeitSelect.find('option[value="' + el.arbeit + '"]').removeAttr('disabled');
            }
          });
        }
      });
      if (!is_sel) {
        $arbeitSelect.find('option').removeAttr('disabled');
      }
      if ($arbeitSelect.find('option:selected:disabled').length) {
        $arbeitSelect.val('');
      }
      $arbeitSelect.customSelect('reset');
    }
  }
  function sendProfileFormData($form, $type) {
    $form.removeClass('invalid');
    $form.find('[aria-invalid="true"]').each(function () {
      $(this).attr('aria-invalid', false).removeClass('not-valid');
    });
    $form.find('.not-valid-tip').remove();
    var formData = new FormData($form.get(0));
    $.ajax({
      url: $form.attr('action'),
      type: 'POST',
      dataType: 'json',
      processData: false,
      contentType: false,
      data: formData,
      action: 'profile_data',
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        successProfileFormData(data, $form, $type);
        pagedLoadPost = 1;
        isLoadPost = true;
      }
    });
  }
  function successProfileFormData(data, $form, $type) {
    if (data.status) {
      $form.find('[type="file"]').val('');
      var savedText = $form.find('.form-submit').data('saved');
      if (typeof savedText != 'undefined') {
        $form.find('.form-submit .btn-text').text(savedText);
      }
      switch ($type) {
        case 'elternarbeit':
          if (typeof data.updated_data != 'undefined') {
            updateArbeit(data, 'filter');
          }
          break;
        case 'mitglieder':
          if (typeof data.updated_data != 'undefined') {
            /*var reloadUrl = window.location.href + '?tab=mitglieder';
            if ( $form.find('tbody').find('.js-remove-mitglieder').length ) {
                window.location.href = reloadUrl;
            }*/
            //$('.tab-list').find('[data-id="elternarbeit"]').attr('href', reloadUrl).removeClass('js-list-filter');
            updateMitglieder(data);
          }
          break;
        case 'kontakt':
          $('.header-title--main').text($('[name="u_first_name"]').val() + ' ' + $('[name="u_last_name"]').val());
          if (typeof userRole != 'undefined' && $form.find('[name="user_role"]').val() != userRole) {
            document.location.reload();
          }
          break;
      }
    } else {
      $form.addClass('invalid');
      if (data.invalid_fields.length) {
        $.each(data.invalid_fields, function (name, value) {
          var $field = $('[name="' + value.name + '"]');
          $field.attr('aria-invalid', true).parent().append('<span class="not-valid-tip" role="alert" aria-hidden="true">' + value.message + '</span>');
          $field.addClass('not-valid');
        });
      }
    }
  }
  function getArbeitByFilter($el, $type) {
    if ($type != 'load') {
      pagedLoadPost = 1;
    }
    var user_id = $el.parents('form').find('[name="user_id"]').val();
    var data = {
      action: 'arbeit_by_filter',
      user_id: user_id,
      paged: pagedLoadPost
    };
    var $export = $el.parents('form').find('.js-export');
    var $exportParams = $export.data('params');
    $el.parents('form').find('.js-ea-search').each(function () {
      data[$(this).attr('name')] = $(this).val();
      if ($export.length) {
        $exportParams[$(this).attr('name')] = $(this).val();
      }
    });
    if ($export.length) {
      var $exportNewUriParams = $.param($exportParams);
      $export[0].search = '?' + $exportNewUriParams;
    }
    $.ajax({
      url: reqObj.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        updateArbeit(data, $type);
        if ($(data.updated_data).length) {
          isLoadPost = true;
        }
      }
    });
  }
  function getMitgliederByFilter($el) {
    var user_id = $el.parents('form').find('[name="user_id"]').val();
    var $export = $el.parents('form').find('.js-export');
    var $exportParams = $export.data('params');
    var data = {
      action: 'mitglieder_by_filter',
      user_id: user_id
    };
    $el.parents('form').find('.js-mitglieder-search').each(function () {
      data[$(this).attr('name')] = $(this).val();
      $exportParams[$(this).attr('name')] = $(this).val();
    });
    var $exportNewUriParams = $.param($exportParams);
    $export[0].search = '?' + $exportNewUriParams;
    $.ajax({
      url: reqObj.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        updateMitglieder(data);
      }
    });
  }
  function removeProfileData(el, type) {
    var post = el.parents('tr').eq(0).find('.data-post').val();
    var data = {
      action: 'remove_profile_data',
      type: type,
      post: post
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {}
    });
  }
  function addNewArbeit(el) {
    var cloneEl = el.parents('tr').eq(0);
    var newEl = cloneEl.clone();
    countArbeit += arbeitWrapp.find('tbody').find('tr').length;
    newEl.removeClass('table-nav').addClass('edit-row new active').find('.custom-select').remove();
    newEl.find('.js-add-arbeit').removeClass('js-add-arbeit').addClass('js-remove-arbeit').find('.icon').removeClass('icon-add"').addClass('icon-remove');
    newEl.find('th').replaceWith(function () {
      return '<td class="' + this.className + '">' + this.innerHTML + '</td>';
    });
    cloneEl.find('input:not(.custom-select__input), select').each(function () {
      var name = $(this).attr('name');
      var $val = $(this).val();
      newEl.find('[name="' + name + '"]').val($val);
      var newName = $(this).attr('name').replace('arbeit[%s]', 'elternarbeit[' + countArbeit + ']');
      newEl.find('[name="' + name + '"]').attr('name', newName);
    });
    if (arbeitWrapp.hasClass('admin')) {
      newEl.find('[name*=ea_chf]').parent().removeClass(['table-date', 'no-edit']);
    }
    newEl.find('.js-save-arbeit').css({
      display: 'block'
    });
    arbeitWrapp.find('tbody').prepend(newEl);
    init_custom_select(newEl);
    updateRowIndex(arbeitWrapp);
  }
  function editArbeit(el) {
    var elWrapp = el.parents('tr').eq(0);
    elWrapp.removeClass('disable').addClass('active');
    elWrapp.find('.no-select, .no-edit').each(function () {
      $(this).removeClass(['no-select', 'no-edit']);
    });
    elWrapp.find('.edit-status').val('edit');
    el.removeClass('js-edit-arbeit').addClass('js-remove-arbeit').find('.icon').removeClass('icon-pen').addClass('icon-remove');
  }
  function getChfArbeit(data, el, type) {
    data.action = 'get_chf_arbeit';
    $.ajax({
      url: reqObj.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        switch (type) {
          case 'edit':
            el.find('[name*=ea_chf]').val(data.price);
            if (data.price_type == 'fix_price') {
              var zeit = el.find('[name*=ea_zeit]');
              zeit.find('option').prop('selected', false);
              zeit.find('option[data-type="fix_price"]').attr('selected', 'selected').prop('selected', true);
              zeit.customSelect('reset');
            }
            break;
        }
      }
    });
  }
  function updateArbeit(data, $type) {
    switch ($type) {
      case 'filter':
        arbeitWrapp.find('tbody').html($(data.updated_data));
        break;
      case 'load':
        arbeitWrapp.find('tbody').append($(data.updated_data));
        break;
    }
    init_custom_select(arbeitWrapp);
  }
  function updateMitglieder(data) {
    mitgliederWrapp.find('tbody').html($(data.updated_data));
    init_custom_select(mitgliederWrapp);
  }
  function addNewMitglieder(el) {
    var cloneEl = el.parents('tr').eq(0);
    var newEl = cloneEl.clone();
    countArbeit += mitgliederWrapp.find('tbody').find('tr').length;
    newEl.removeClass('table-nav').addClass('edit-row new active').find('.custom-select').remove();
    newEl.find('.js-add-mitglieder').removeClass('js-add-mitglieder').addClass('js-remove-mitglieder').find('.icon').removeClass('icon-add"').addClass('icon-remove');
    newEl.find('th').replaceWith(function () {
      return '<td class="' + this.className + '">' + this.innerHTML + '</td>';
    });
    cloneEl.find('input:not(.custom-select__input), select').each(function () {
      var name = $(this).attr('name');
      var $val = $(this).val();
      newEl.find('[name="' + name + '"]').val($val);
      var newName = $(this).attr('name').replace('mitglieder_new[%s]', 'mitglieder[' + countArbeit + ']');
      newEl.find('[name="' + name + '"]').attr('name', newName);
    });
    mitgliederWrapp.find('tbody').prepend(newEl);
    init_custom_select(newEl);
    updateRowIndex(mitgliederWrapp);
  }
  function updateRowIndex(el) {
    el.find('tbody tr').each(function (idx) {
      var num = idx + 1;
      num = num < 10 ? '0' + num : num;
      $(this).find('.index').text(num);
    });
  }
  function init_custom_select(wrapp) {
    wrapp.find(".modal-input:not(.search-field) > select").customSelect();
    wrapp.find(".modal-input.search-field > select").customSelect({
      search: true
    });
    wrapp.find('[data-toggle="datepicker"]').datepicker({
      format: "dd.mm.yyyy",
      days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      weekStart: 1,
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    });
  }
})(jQuery);